import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "lc_sogutma_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
    baseURL: API,
    // Bearer token in Authorization header is sufficient (no cookies needed).
    // Disabling withCredentials avoids CORS issues across custom domains.
    withCredentials: false,
});

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

export const formatApiError = (e) => {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || "Bir hata oluştu";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
            .join(" ");
    }
    if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};

export const KLIMA_OPTIONS = [
    "AC200EQ-134",
    "AC200EQX-404",
    "AC300EQ-134",
    "AC300EQX-404",
    "AC400EQ-134",
    "AC400EQX-404",
];
